/* eslint-disable no-unused-vars */
import React from 'react';
import { Input, Modal } from 'antd';
import MenuCategoryActions from '../../redux/middleware/menuCategory';
import MenuCategoryBuilderActions from '../../redux/middleware/menuCategoryBuilder';
import CategoryActions from '../../redux/middleware/category';
import IngredientCategoryBuilderActions from '../../redux/middleware/ingredientCategoryBuilder';

import './style.scss';
import Utils from '../../redux/utils';
type Props = {
  handleDialog: any;
  open: boolean;
  component?: any;
  name?: any;
  modalName?: any;
  parentCategory?: any;
};

const CategoryModal = (props: Props) => {
  const company = Utils.getCurrentCompany();
  const brand = Utils.getCurrentBrand();
  let { handleDialog, open, component, name, modalName, parentCategory } =
    props;
  const [menuCategory, setMenuCategory] = React.useState(name);

  const handleSubmit = async () => {
    const paramForBuilder = {
      company_id: company?.id,
      category_name: menuCategory,
      brand_id: brand?.brand_id,
    };
    const param = {
      company_id: company?.id,
      category_name: menuCategory,
      brand_id: brand?.brand_id,
    };
    const paramForRdSubRecipe = {
      company_id: company?.id,
      category_name: menuCategory,
    };
    const paramsForSubRecipe = {
      company_id: company?.id,
      parent_category_id: parentCategory,
      sub_category: menuCategory,
      brand_id: brand?.brand_id,
    };
    let response;
    // const response =
    // component == 'rd_ingredient_category'
    //   ? await IngredientCategoryBuilderActions.addIngredientCategoryBuilder(
    //       paramForRdSubRecipe
    //     )
    //   : component == 'recipebuilder'
    //   ? await MenuCategoryBuilderActions.addMenuCategoryBuilder(
    //       paramForBuilder
    //     )
    //   : component == 'marketlist'
    //   ? await CategoryActions.createIngredientCategory(param)
    //   : await MenuCategoryActions.addMenuCategory(param);
    switch (component) {
      case 'sub_recipe':
        response = await MenuCategoryActions.addSubCategories(
          paramsForSubRecipe
        );
        break;
      case 'rd_ingredient_category':
        response =
          await IngredientCategoryBuilderActions.addIngredientCategoryBuilder(
            paramForRdSubRecipe
          );
        break;
      case 'recipebuilder':
        response = await MenuCategoryBuilderActions.addMenuCategoryBuilder(
          paramForBuilder
        );
        break;
      case 'marketlist':
        response = await CategoryActions.createIngredientCategory(param);
        break;
      default:
        response = await MenuCategoryActions.addMenuCategory(param);
    }
    handleFetchCategory(response);
  };
  const handleMenuCategory = (data: string) => {
    setMenuCategory(data);
  };

  const handleFetchCategory = (response: any) => {
    if (response?.success) {
      handleDialog(false, response?.data);
    }
  };

  return (
    <div className="CategoryModal">
      <Modal
        title={<div className="title font">Add New Category</div>}
        centered
        open={open}
        onCancel={() => handleDialog(false, {})}
        width={608}
        footer={null}
      >
        <div className="Modal">
          <div className="ingredientCategoryContainerWidth">
            <div className="wizardSubContainer case">
              <div className="CategoryModalwizardLabel">
                {modalName} Category Name <span className="sterik">*</span>
              </div>
              <Input
                placeholder="Enter Menu Category Name"
                size="large"
                value={menuCategory}
                onChange={(e) => {
                  handleMenuCategory(e.target.value);
                }}
                required
              />
            </div>
          </div>
          <div className="butonGroup">
            <div
              className="wizard-button"
              onClick={() => handleDialog(false, {})}
            >
              Back
            </div>
            <div className="continue wizard-button" onClick={handleSubmit}>
              Submit
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CategoryModal;
